<template>
<div>

    <v-dialog v-model="dialog" persistent scrollable fullscreen>
        <v-card>
            <v-card-title class="text-h5 pl-6 font-weight-regular">Deal Detail
                <v-spacer/><v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title><v-divider/>
            <v-progress-linear :active="loading" :indeterminate="true"/>
            <v-card-text class="mt-4">
                <v-row>
                    <v-col cols="8" class="pr-3">
                        <v-card class="pa-4 mb-3">
                            <v-card-title class="card-title text-h5 font-weight-medium" style="display: block">Basic Info
                                <v-menu offset-y :close-on-content-click="false" v-model="menu" v-if="deal">
                                    <template v-slot:activator="{ on}">
                                        <v-btn v-on="on" :style="`background:${Constants.DealStatusColor[deal.statusId]}`" dark
                                               class="elevation-0 mr-3 float-right">{{deal.Status.status}}<v-icon right>mdi-menu-down</v-icon></v-btn>
                                    </template>
                                    <v-list dense v-show="![Constants.DealStatuses.Approved, Constants.DealStatuses.Rejected].includes(deal.statusId)">
                                        <v-progress-linear :indeterminate="updateStatusLoading" absolute bottom></v-progress-linear>
                                        <v-list-item-group color="primary">
                                            <v-list-item v-for="(s, idx) in statuses" @click="onSelectStatus(deal, s.id)" :key="'status'+idx">
                                                <v-list-item-icon>
                                                    <v-icon :style="`color:${Constants.DealStatusColor[s.id]}`" >mdi-checkbox-blank</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title> {{ s.status }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-menu>
                            </v-card-title>
                            <v-card-text v-if="deal" class="pb-14">
                                <h2 class="text-h4 font-weight-regular my-5">#{{deal.dealNumber}}</h2>
                                <v-row>
                                    <v-col class="text-uppercase " cols="4">Deal Date<br><span class="text-h6 font-weight-regular black--text text-capitalize">{{ moment(deal.created_at).format('DD-MM-YYYY hh:mm A') }}</span></v-col>
                                    <v-col class="text-uppercase " cols="4">Last Updated<br><span class="text-h6 font-weight-regular black--text text-capitalize">{{ moment(deal.updated_at).format('DD-MM-YYYY hh:mm A') }}</span></v-col>
                                    <v-col class="text-uppercase " cols="4" v-if="deal.approved_at">Approved On<br><span class="text-h6 font-weight-regular black--text text-capitalize">{{ moment(deal.approved_at).format('DD-MM-YYYY hh:mm A') }}</span></v-col>
                                    <v-col class="text-uppercase " cols="4" v-if="deal.rejected_at">Rejected On<br><span class="text-h6 font-weight-regular black--text text-capitalize">{{ moment(deal.rejected_at).format('DD-MM-YYYY hh:mm A') }}</span></v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <v-card  class="pa-4 pb-6">
                            <v-card-title class="card-title text-h5 font-weight-medium" style="display: block">Deal Note</v-card-title>
                            <v-card-text v-if="deal">
                                <v-textarea outlined v-model="dealNote" :readonly="deal.note&&!editNote" :class="deal.note&&!editNote?'no-border mb-2':'mb-2'"
                                            ref="note-textArea" :rows="4" placeholder="Enter note..." :counter-value="(v) => v&&numOfWords(v)+'/500'||'0/500'" counter
                                            :rules="[v => !!v || 'Note Required', v => v.length>=3 || 'Minimum 3 characters', v => numOfWords(v)<= 500 || 'Maximum 500 words']"/>
                                <v-btn v-if="!deal.note" class="note-btn primary" @click="saveNote" :disabled="($refs['note-textArea']&&$refs['note-textArea'].hasError || !dealNote)" :loading="noteLoading">Add Note</v-btn>
                                <v-btn v-if="deal.note&&!editNote" class="note-btn primary" @click="editNote=true;$refs['note-textArea'].focus()">Edit Note</v-btn>
                                <v-btn v-if="deal.note&&editNote" class="note-btn primary" @click="saveNote" :disabled="($refs['note-textArea']&&$refs['note-textArea'].hasError)" :loading="noteLoading">Save</v-btn>
                                <v-btn v-if="deal.note&&editNote" class="note-btn mr-4" @click="editNote=false;dealNote=deal.note">Cancel</v-btn>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="4">
                        <v-card height="100%" class="pa-4">
                            <template v-if="deal">
                                <v-card-title class="card-title text-h5 font-weight-medium">{{deal.Customer.name}}</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="6" class="pt-0 pb-0">
                                            <div class="d-flex">
                                                <v-icon class="text-h6 customer-detail-icon">mdi-cellphone</v-icon>
                                                <span class="text-h6 font-weight-regular black--text">{{deal.Customer.mobile}}</span>
                                            </div>

                                            <div class="pt-0 pb-0 d-flex align-baseline" v-if="deal.Customer.email">
                                                <v-icon class="customer-detail-icon text-h6">mdi-email</v-icon>
                                                <span class="text-h6 font-weight-regular black--text d-block" style="width: 100%">{{deal.Customer.email}}</span>
                                            </div>

                                            <div class="pt-0 d-flex align-baseline" v-if="deal.Customer.city">
                                                <v-icon class="customer-detail-icon text-h6">mdi-map-marker</v-icon>
                                                <span class="text-h6 font-weight-regular black--text">{{deal.Customer.city}}</span>
                                            </div>
                                        </v-col>
                                        <v-col cols="6" style="margin-top: -55px;" class="d-flex justify-end">
                                            <div>
                                                <div>
                                                    <v-avatar size="100" tile @click="openGallery([{path: deal.Customer.profileImage, type: 'IMAGE'}])" class="avatar" title="View Image">
                                                        <v-icon v-if="!deal.Customer.profileImage" size="50">mdi-account-circle</v-icon>
                                                        <v-img v-else :src="imgWpx(deal.Customer.profileImage, 200)" :alt="deal.Customer.name" @error="deal.Customer.profileImage = null">
                                                            <template v-slot:placeholder>
                                                                <v-icon size="100" color="blue-grey lighten-5">mdi-account-circle</v-icon>
                                                                <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                                                            </template>
                                                        </v-img>
                                                    </v-avatar>
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </template>
                        </v-card>
                    </v-col>
                    <v-col cols="12">
                        <v-card class="mb-6 mt-3 pa-4">
                            <v-card-title class="card-title text-h5 font-weight-medium">Products</v-card-title>
                            <v-card-text v-if="deal">
                                <v-data-table :headers="headers" :items="deal.DealItems">
                                    <template class="text-body-2" v-slot:item.product="{ item }">
                                        <v-avatar tile @click="openGallery(item.Product.Attachments)" style="border: 1px solid grey; border-radius: 5px !important;"  class="avatar my-3 mr-6" size="34" title="View Image">
                                            <v-img v-if="item.Product.Attachments.length" :src="imgWpx(item.Product.Attachments[0].path, 200)" max-width="44" max-height="44">
                                                <template v-slot:placeholder><v-icon size="100" color="blue-grey lighten-5">mdi-image</v-icon>
                                                    <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                                                </template>
                                            </v-img>
                                            <v-icon v-else size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                                        </v-avatar>
                                        <span class="ellipsis product-name">
                                            <span :title="item.Product.name">{{ item.Product.name}}</span><br>
                                            <span :title="item.Product.sku" class="f-12 grey--text text--darken-1">{{item.Product.sku}}</span>
                                        </span>
                                    </template>
                                    <template v-slot:item.purchasePrice="{ item }"><span class="cell-qty" style="font-size: 16px">{{ item.Product.purchasePrice  | currencyFilter}}</span></template>
                                    <template v-slot:item.sellingPrice="{ item }"><span class="cell-qty" style="font-size: 16px">{{ item.Product.displayPrice  | currencyFilter}}</span></template>
                                    <template v-slot:item.totalPieces="{ item }"><span class="cell-qty" style="font-size: 16px">{{ item.cartoons * item.Product.cartonQty}}</span></template>
                                    <template v-slot:item.totalQty="{ item }">
                                        <v-tooltip right content-class="stock-tooltip">
                                            <template v-slot:activator="{ on }"><span v-on="on">{{ item.Product.KatargamStock[0].totalQty}}</span></template>
                                            <ul class="stock-tooltip-content">
                                                <li v-for="(w, idx) in item.Product.WarehouseStock" :key="idx">
                                                    <span>{{w.Warehouse.name}}:</span> <span>{{w.totalQty}}</span>
                                                </li>
                                            </ul>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:item.pricePerPiece="{ item }"><span class="cell-qty" style="font-size: 16px">{{ item.pricePerPiece | currencyFilter }}</span></template>
                                    <template v-slot:item.totalPrice="{ item }"><span class="cell-total" style="font-size: 16px">{{(item.pricePerPiece*item.Product.cartonQty*item.cartoons) | currencyFilter }}</span></template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>

    <gallery id="gallery-c-detail" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"/>
    <Snackbar :toaster="toaster"/>
</div>
</template>

<script>
import Constants from "../../Constants/Constants";
import moment from "moment";
import {SUBSCRIBE_DEAL_BY_ID} from "../../graphql/subscriptions/Deals";
import gallery from '../../mixins/gallery';
import updateRecord from '../../mixins/updateRecord';
import Snackbar from "../../components/Common/Snackbar";
import {GET_DEAL_STATUS} from "../../graphql/queries/Deals";
export default {
    name: "DealDetail",
    components: {Snackbar},
    props: ['dialog', 'id'],
    mixins: [gallery, updateRecord],
    apollo:{
        $subscribe:{
            Deals:{
                query: SUBSCRIBE_DEAL_BY_ID,
                skip () {return !this.id || !this.dialog},
                variables () { return {id: this.id} },
                result ({ data }) { this.deal = data.Deals[0]; this.loading = false;
                                    this.dealNote = this.deal.note || this.dealNote },
            }
        },
        statuses: { query: GET_DEAL_STATUS }
    },
    data(){
        return{
            Constants, moment,
            user: JSON.parse(localStorage.user),
            deal: null,
            headers: [
                { text: 'PRODUCT', value: 'product', width:300 }, { text: 'PIECE/CARTOON', value: 'Product.cartonQty' },
                { text: 'PURCHASE PRICE', value: 'purchasePrice', align:'end'},{ text: 'SELLING PRICE', value: 'sellingPrice', align:'end'},
                { text: 'DEAL CARTOON', value: 'cartoons', align:'end'}, { text: 'TOTAL PIECES', value: 'totalPieces', align:'end'},
                { text: 'AVAIL. STOCK', value: 'totalQty', align: 'end'}, { text: 'DEAL PRICE', value: 'pricePerPiece', align: 'end'},
                { text: 'TOTAL', value: 'totalPrice', align: 'end' }
            ],
            loading: true,
            toaster: {enable: false},
            menu: false,
            statuses: [],
            updateStatusLoading: false,
            dealNote: '',
            editNote: false,
            noteLoading: false,
            numOfWords: (v) => v.trim().split(/\s+/).length
        }
    },
    methods:{
        async onSelectStatus(row, statusId){
            if(statusId === row.statusId || [Constants.DealStatuses.Approved, Constants.DealStatuses.Rejected].includes(row.statusId)) return;
            this.updateStatusLoading = true;
            let obj = { statusId, updatedBy:this.user.id };
            if(statusId === Constants.DealStatuses.Approved) obj['approved_at'] = moment().format();
            if(statusId === Constants.DealStatuses.Rejected) obj['rejected_at'] = moment().format();
            await this.updateRecord(row.id, obj, 'Deals');
            this.updateStatusLoading = false;
            this.menu = false;
            this.toaster = {enable:true, color:'green', message: `Deal Status Updated Successfully`};
        },
        async saveNote() {
            this.noteLoading = true;
            await this.updateRecord(this.id, {note: this.dealNote}, 'Deals');
            this.noteLoading = false;
            this.toaster = {enable:true, color:'green', message: `Note saved Successfully`};
            this.editNote = false;
        },
        closeDialog(){
            this.$refs['note-textArea'].resetValidation();
            this.$emit('update:dialog', false);
            this.$emit('update:id', null);
            this.loading = true;
            this.dealNote = '';
        }
    }
}
</script>

<style scoped>
/deep/.v-application .text-h5, .v-application .text-h6{
    font-family: 'Quattrocento Sans', sans-serif !important;
}
/deep/.v-application .text-h3, .v-application .text-h4{
    font-family: 'Quattrocento Sans', sans-serif !important;
}
/deep/.v-application .text-body-2, .v-application .text-button{
    font-family: 'Quattrocento Sans', sans-serif !important;
}
.card-title{
    font-weight: 600;
    font-size: 20px;
}
.customer-detail-icon{
    font-size: 14px;
    margin-right: 10px;
}
.customer-name{
    margin: 0px 0px 0 -32px;
}
.avatar{
    cursor: pointer;
}
.note-btn{
    margin: -15px 0 0 0 ;
    float: right;
}
/deep/ .no-border fieldset{
    border: none;
}
.ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
}
.product-name {
    display: inline-block;
    vertical-align: middle;
    width: 200px;
    max-width: 200px;
}
</style>